import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <section className="py-12 md:py-24 bg-white dark:bg-slate-900 overflow-hidden" id="about">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Image Section */}
          <div className="lg:w-1/2 relative group">
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-primary/10 rounded-full blur-3xl group-hover:bg-primary/20 transition-colors duration-500"></div>
            <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-secondary/10 rounded-full blur-3xl group-hover:bg-secondary/20 transition-colors duration-500"></div>

            <img
              alt="Young professional dentist"
              className="rounded-2xl shadow-soft relative z-10 w-full object-cover h-[500px] border border-slate-100 dark:border-slate-800"
              src="/images/gallery-interior-art.jpg"
            />

            <div className="absolute bottom-4 left-4 right-4 md:bottom-8 md:left-8 md:right-8 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm p-4 md:p-6 rounded-xl shadow-lg z-20 border border-slate-100 dark:border-slate-700">
              <div className="flex items-start gap-4">
                <div className="text-secondary text-3xl md:text-4xl leading-none font-serif opacity-50">
                  <i className="fas fa-quote-left"></i>
                </div>
                <div>
                  <p className="text-slate-700 dark:text-slate-200 italic font-light text-base md:text-lg">
                    "Our goal is to serve you with the best quality dental care using cutting-edge technology right here in Kottawa."
                  </p>
                  <p className="text-xs md:text-sm text-primary font-bold mt-2 uppercase tracking-wide">
                    — Chief Dental Surgeon
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="lg:w-1/2">
            <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-xs font-bold tracking-widest uppercase rounded-full mb-6">
              Who We Are
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white mb-8 leading-tight">
              Welcome to <span className="text-primary">Smile Care</span>
            </h2>

            <p className="text-slate-600 dark:text-slate-400 mb-6 leading-relaxed text-lg font-light">
              Smile Care Dental Surgery (VIP Center) is a fully equipped modern Dental Clinic in Kottawa providing
              General Dental Care to Advanced Dental Procedures like Implants and Orthodontics, suited to meet the specific needs of every patient.
            </p>

            <p className="text-slate-600 dark:text-slate-400 mb-8 leading-relaxed font-light">
              Our friendly and caring staff provides professional and individualized attention to each and every patient.
              At Smile Care Dental Surgery, your safety, comfort, concern, and satisfaction are our top priorities.
            </p>

            <ul className="space-y-4 mb-10">
              <li className="flex items-center gap-4 group">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                  <i className="fas fa-shield-virus"></i>
                </div>
                <span className="text-slate-700 dark:text-slate-200 font-medium">Plasma Air Bipolar Ionization Technology</span>
              </li>
              <li className="flex items-center gap-4 group">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                  <i className="fas fa-couch"></i>
                </div>
                <span className="text-slate-700 dark:text-slate-200 font-medium">Comfortable, Modern Treatment Areas</span>
              </li>
              <li className="flex items-center gap-4 group">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <span className="text-slate-700 dark:text-slate-200 font-medium">Located conveniently in Kottawa</span>
              </li>
            </ul>

            <Link className="text-primaryDark dark:text-primary font-semibold hover:underline" to="/about-us">
              Learn more about our team <i className="fas fa-arrow-right ml-1"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
